// Pure enums/helpers — RSC-safe (no styled-components/react imports).
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Product Type (Engraving disabled for Diesel Ring)
export enum DieselRingType {
  NOT_ENGRAVED = 'NOT_ENGRAVED',
  // No ENGRAVED option for Diesel Ring
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getEngravingKey = (ip: boolean | null | string) => {
  // Always return NOT_ENGRAVED for Diesel Ring
  return DieselRingType.NOT_ENGRAVED;
};

export type DieselRingVariantType = {
  variantId: Partial<Record<ShopifyStore, string>>;
  checkoutUrl: Partial<Record<ShopifyStore, string>>;
  fastDelivery?: boolean;
  SKU?: string;
  misc?: Record<MiscDieselRingCheckoutTypes, any>;
};

// Only 2 colors for Diesel Ring
export enum DieselRingColors {
  CRYO = 'CRYO',
  PHANTOM = 'PHANTOM',
}

// Standard ring sizes (same as Ring Air)
export enum DieselRingSizes {
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14,
  OPEN = 99, // If sizing kit is available
}

// Flat pricing: $499 USD across both colors
export const DieselRingPriceData: Record<
  ShopifyStore,
  Record<DieselRingColors, { striked_price: number; price: number }>
> = {
  [ShopifyStore.IN]: {
    [DieselRingColors.CRYO]: { striked_price: 43889, price: 43889 }, // ~499 USD → INR
    [DieselRingColors.PHANTOM]: { striked_price: 43889, price: 43889 },
  },
  [ShopifyStore.ROW]: {
    [DieselRingColors.CRYO]: { striked_price: 499, price: 499 },
    [DieselRingColors.PHANTOM]: { striked_price: 499, price: 499 },
  },
  [ShopifyStore.US]: {
    [DieselRingColors.CRYO]: { striked_price: 499, price: 499 },
    [DieselRingColors.PHANTOM]: { striked_price: 499, price: 499 },
  },
  [ShopifyStore.AE]: {
    [DieselRingColors.CRYO]: { striked_price: 1831, price: 1831 },
    [DieselRingColors.PHANTOM]: { striked_price: 1831, price: 1831 },
  },
  [ShopifyStore.GB]: {
    [DieselRingColors.CRYO]: { striked_price: 469, price: 469 }, // ~499 USD → GBP
    [DieselRingColors.PHANTOM]: { striked_price: 469, price: 469 },
  },
  [ShopifyStore.EU]: {
    [DieselRingColors.CRYO]: { striked_price: 559, price: 559 }, // ~499 USD → EUR
    [DieselRingColors.PHANTOM]: { striked_price: 559, price: 559 },
  },
  [ShopifyStore.CA]: {
    [DieselRingColors.CRYO]: { striked_price: 685, price: 685 },
    [DieselRingColors.PHANTOM]: { striked_price: 685, price: 685 },
  },
  [ShopifyStore.AU]: {
    [DieselRingColors.CRYO]: { striked_price: 879, price: 879 },
    [DieselRingColors.PHANTOM]: { striked_price: 879, price: 879 },
  },
  [ShopifyStore.SA]: {
    [DieselRingColors.CRYO]: { striked_price: 2159, price: 2159 },
    [DieselRingColors.PHANTOM]: { striked_price: 2159, price: 2159 },
  },
  [ShopifyStore.MX]: {
    [DieselRingColors.CRYO]: { striked_price: 10629, price: 10629 },
    [DieselRingColors.PHANTOM]: { striked_price: 10629, price: 10629 },
  },
  [ShopifyStore.ZA]: {
    [DieselRingColors.CRYO]: { striked_price: 10449, price: 10449 },
    [DieselRingColors.PHANTOM]: { striked_price: 10449, price: 10449 },
  },
  [ShopifyStore.JP]: {
    [DieselRingColors.CRYO]: { striked_price: 84800, price: 84800 },
    [DieselRingColors.PHANTOM]: { striked_price: 84800, price: 84800 },
  },
};

// NO CHARGER OPTIONS for Diesel Ring (only original included)
// NO ENGRAVING for Diesel Ring

// Misc checkout types (if special checkout flows needed)
export enum MiscDieselRingCheckoutTypes {}
// Add if needed

// Static shipping message
export const DIESEL_RING_STATIC_SHIPPING =
  'Ships in 6-8 weeks (depending on your ring size)';

// Default stores for striked pricing
export const DEFAULT_PRICE_STRIKED_STORES: Array<ShopifyStore> = [];
